import React, { FC, useState } from 'react'
import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { DeviceOverview, DeviceOverviewData } from '../../api/mobilbase/models';
import { useLocation } from 'react-router-dom';
import { RouteLocationProps } from '../../routes/mobilbase';
import APIRequestDeviceOverview from '../../components/helpers/APIRequestDeviceOverview';
import DeviceOverviewTable from '../../components/Table/DeviceOverviewTable';
import DeviceOverviewDialog from '../../components/dialogs/DeviceOverviewDialog';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    grid: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
}));

interface Props {
  navFunc: ((historyState: RouteLocationProps) => void)
}

const DeviceOverviewPage: FC<Props> = ({ navFunc }) => {
  const classes = useStyles();
  const routeLocation = useLocation<RouteLocationProps>();
  const {selectedLocationId, selectedLocationName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
  const [data, setData] = useState<DeviceOverview>({elements: [], locationName: ""});
  const [isPending, setIsPending] = useState(false);
  const [run, setRun] = useState(true);
  const [selectedDeviceId, setSelectedDeviceId] = useState(0);
  const [selectedDeviceName, setSelectedDeviceName] = useState('');
  const [dialogState, setDialogState] = React.useState<{open: boolean, offline: boolean}>({open: false, offline: false});

  const handleOpenDialog = (element: DeviceOverviewData) => {
    const isOffline = element.power === '-' && element.door === '-' && element.inUse === '-' && element.printer === '-' && element.card === '-' && element.coin === '-' && element.display === '-';
    setSelectedDeviceId(element.deviceID);
    setSelectedDeviceName(element.name);
    setDialogState({open: true, offline: isOffline});
  };

  const handleCloseDialog = (value: string) => {
    setDialogState({open: false, offline:false});
    if (value === "log") {
      navFunc(new RouteLocationProps(3, selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName));
    } else if (value === "manage" && !dialogState.offline) {
      navFunc(new RouteLocationProps(4, selectedLocationId, selectedLocationName, selectedDeviceId, selectedDeviceName))
    }
  };

  
  return (
    <Container maxWidth={false}>
      <APIRequestDeviceOverview
      //API request for device overview data
      run={run}
      setRun={setRun}
      isPending={isPending}
      setIsPending={setIsPending}
      selectedLocationId={selectedLocationId}
      setData={setData}
      />
      <div className={classes.paper}>
            <Typography component="h1" variant="h5">
                Automatoversigt - {((selectedLocationName) ? selectedLocationName : "INGEN VALGT")}
            </Typography>
        <div className={classes.grid}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <DeviceOverviewTable
                //Display overview data in table 
                  data={mapDeviceOverviewData(data)}
                  isPending={isPending}
                  handleOpenDialog={handleOpenDialog}
                  setRun={setRun}
                />
            </Grid>
          </Grid>
        </div>
      </div>
        <DeviceOverviewDialog 
        open={dialogState.open} //toggle open based on state
        onClose={handleCloseDialog} //handle close action
        offlineOpen={dialogState.offline} //toggle offlineopen based on state
        />
    </Container>      
  );
}

export default DeviceOverviewPage;

export const mapDeviceOverviewData = (data: DeviceOverview | undefined) => {
  if (!data || !data.elements) {
    return []
  }
    return data.elements.map(d => {
      var l = {...d}  
      l.coinbox = (l.coinbox === -1) ? "-" : l.coinbox;
      l.printerCount = (l.printerCount === -1) ? "-" : l.printerCount;
      return l;
    });
}